import { CommonModule } from '@angular/common';
import { Component, inject, signal, OnInit } from '@angular/core';
import { RouterLink, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import {
  ShamDelete02Icon,
  ShamEdit01Icon,
  ShamPlus03Icon,
} from 'sham-components/icons';
import { TranslateModule } from '@ngx-translate/core';

import { AddressService, Address } from '../../services/address.service';
import { CartApi } from '@/app/services/cart-api';
import { EmptyPage } from '@/app/layouts/empty-page/empty-page';

@Component({
  selector: 'app-shipping-address',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ShamPlus03Icon,
    ShamEdit01Icon,
    TranslateModule,
    ShamDelete02Icon,
    EmptyPage,
  ],
  templateUrl: './shipping-address.html',
  styleUrl: './shipping-address.css',
})
export class ShippingAddressPage implements OnInit {
  private addressService = inject(AddressService);
  private router = inject(Router);
  private cartApi = inject(CartApi);
  addresses = signal<Address[]>([]);
  selectedAddressId = signal<string | null>(null);
  selectionErrorKey = signal<string | null>(null);
  ngOnInit() {
    this.loadAddresses();
  }

  loadAddresses() {
    this.addressService.getAddresses().subscribe({
      next: (data) => {
        this.addresses.set(data);
        this.cartApi.getCheckoutCurrent().subscribe({
          next: (response) => {
            const checkoutAddressId =
              response.checkout?.addressSelection.selectedAddressId;
            const selected =
              data.find(
                (address) =>
                  address.id === checkoutAddressId && address.isDeliveryReady,
              ) ??
              data.find((address) => address.isDefault && address.isDeliveryReady);
            this.selectedAddressId.set(selected?.id ?? null);
          },
          error: () => {
            const selected = data.find(
              (address) => address.isDefault && address.isDeliveryReady,
            );
            this.selectedAddressId.set(selected?.id ?? null);
          },
        });
      },
    });
  }

  selectAddress(addr: Address) {
    if (!addr.isDeliveryReady) {
      this.selectionErrorKey.set('addressReadiness.notReady');
      return;
    }
    this.selectionErrorKey.set(null);
    this.selectedAddressId.set(addr.id);
  }

  addNewAddress() {
    this.router.navigate(['/shipping-address-form']);
  }

  editAddress(addr: Address) {
    this.router.navigate(['/shipping-address-form'], { state: { address: addr } });
  }

  deleteAddress(id: string) {
    this.addressService.deleteAddress(id).subscribe({
      next: () => {
        this.loadAddresses();

        if (this.selectedAddressId() === id) {
          this.selectedAddressId.set(null);
        }
      },
      error: (err) => console.error('Error deleting address:', err),
    });
  }
  goBack() {
    window.history.back();
  }
  confirmSelection() {
    const id = this.selectedAddressId();

    if (!id) return;

    this.cartApi.setShippingAddress(id).subscribe({
      next: () => {
        this.router.navigate(['/checkout'], { replaceUrl: true });
      },
      error: (error: unknown) => {
        const response = error as {
          error?: { error?: { code?: string }; code?: string };
        };
        const code = response.error?.error?.code ?? response.error?.code;
        this.selectionErrorKey.set(
          code === 'Sham.Checkout.DeliveryLocationNotReady'
            ? 'checkout.deliveryLocationNotReady'
            : 'checkout.deliveryQuoteFailed',
        );
      },
    });
  }
}
